// extracted by mini-css-extract-plugin
export default {"card":"CardSellers_card__bA34p","header":"CardSellers_header__eHzAF","photo":"CardSellers_photo__M+zUW","name":"CardSellers_name__iYZtP","link":"CardSellers_link__gxROP"};